import ExportJsonExcel from 'js-export-excel'

/**
 * Exports data as an Excel file and downloads it
 * @param data - Array of objects to export (each object will be a row in the Excel file)
 * @param title - Excel file title/filename
 * @param sheetName - Optional name for the Excel sheet (unused in the implementation)
 */
const downloadXLS = <T extends Record<string, any>>(
  data: T[],
  title: string,
  sheetName?: string
): void => {
  if (!data.length) {
    /* console.warn('No data to export to Excel') */
    return
  }

  const options = {
    fileName: title,
    datas: [
      {
        sheetData: data,
        sheetHeader: Object.keys(data[0]),
        sheetName: sheetName || 'Sheet1'
      }
    ]
  }

  const excelExporter = new ExportJsonExcel(options)
  excelExporter.saveExcel()
}

export default downloadXLS
